import {apiHelper,PromiseHandler} from "../redux/apiHelper"
const deleteStateById=(id)=>PromiseHandler(apiHelper('delete',`/api/admin/state/delete/${id}`))
const getStates=()=>PromiseHandler(apiHelper('get','/api/admin/state/list'))
const getStateById=(id)=>PromiseHandler(apiHelper('get',`/api/admin/state/get/${id}`))
const updateStateById=(id,data)=>PromiseHandler(apiHelper('post',`/api/admin/state/update/${id}`,data))
const addState=(data)=>PromiseHandler(apiHelper('post','/api/admin/state/create',data))
export {deleteStateById,getStates,getStateById,updateStateById,addState}
